import XrCardAv from "../../../components/XrCardAv.tsx";
import XrTextAv from '../../../components/XrTextAv.tsx';
import XrInputAv from '../../../components/XrInputAv.tsx';
import XrButtonAv from '../../../components/XrButtonAv.tsx';
import { useEffect, useState } from "react";

const FormActivity = (props) => {
  const [startDate, setStartDate] = useState('');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [errors, setErrors] = useState({
    startDate: [],
    startTime: [],
    endTime: []
  });

  useEffect(() => {
    const newErrors = {...errors};
    if (props.errors.end_date.length > 0) {
      newErrors.endTime = [ 'Jam selesai wajib diisi.' ];
    } else {
      newErrors.endTime = [];
    }
    if (props.errors.start_date.length > 0) {
      newErrors.startDate = [ 'Tanggal mulai wajib diisi.' ];
    } else {
      newErrors.startDate = [];
    }
    if (props.errors.start_date.length > 0) {
      newErrors.startTime = [ 'Waktu mulai wajib diisi.' ];
    } else {
      newErrors.startTime = [];
    }
    setErrors(newErrors);
  }, [props.errors.start_date, props.errors.end_date])
  
  const onChangeEstimateParticipant = (e) => {
    if (isNaN(parseInt(e.target.value))) return;
    props.setErrors({ ...props.errors, estimate_participant: [] })
    props.setForm({...props.form, estimate_participant: e.target.value });
  };

  const onChangeStartTime = (e) => {
    setErrors({ ...errors, startTime: [] })
    setStartTime(e.target.value);
  };

  const onChangeEndTime = (e) => {
    setErrors({ ...errors, endTime: [] })
    setEndTime(e.target.value);
  };

  const onChangeStartDate = (e) => {
    setErrors({ ...errors, startDate: [] })
    setStartDate(e.target.value);
  };

  const onChangeNotes = (e) => {
    props.setErrors({ ...props.errors, notes: [] })
    props.setForm({...props.form, notes: e.target.value });
  };

  const onChangeDescription = (e) => {
    props.setErrors({ ...props.errors, description: [] })
    props.setForm({...props.form, description: e.target.value });
  };

  useEffect(() => {
    if (startDate && startTime && endTime) {
      const _startDate = `${startDate} ${startTime}`;
      const _endDate = `${startDate} ${endTime}`;
      props.setErrors({ ...props.errors, start_date: [], end_date: [] })
      props.setForm({...props.form, start_date: _startDate, end_date: _endDate });
    }
  }, [startDate, startTime, endTime]);

  return (
    <XrCardAv>
      <div className="card--title">
        <XrTextAv tag='h2' variant='title'>
          Detail Kegiatan
        </XrTextAv>
        <XrTextAv tag='p' variant='description'>
          Informasi kegiatan yang akan dilaksanakan
        </XrTextAv>
      </div>
      <div className="card--body">
        <XrInputAv
          type='text'
          required={true}
          label='Nama Kegiatan'
          disabled={props.isLoading}
          isLoading={props.isLoading}
          value={props.form.description}
          onChange={onChangeDescription}
          errorMessage={props.errors.description}
        />
        <XrInputAv
          type='number'
          required={true}
          label='Estimasi Jumlah Peserta'
          disabled={props.isLoading}
          isLoading={props.isLoading}
          value={props.form.estimate_participant}
          onChange={onChangeEstimateParticipant}
          errorMessage={props.errors.estimate_participant}
        />
        <XrInputAv
          type='date'
          required={true}
          label='Tanggal Meminjam'
          disabled={props.isLoading}
          isLoading={props.isLoading}
          value={startDate}
          onChange={onChangeStartDate}
          errorMessage={errors.startDate}
        />
        <XrInputAv
          type='time'
          required={true}
          label='Jam Mulai Meminjam'
          disabled={props.isLoading}
          isLoading={props.isLoading}
          value={startTime}
          onChange={onChangeStartTime}
          errorMessage={errors.startTime}
        />
        <XrInputAv
          type='time'
          required={true}
          label='Jam Selesai Meminjam'
          disabled={props.isLoading}
          isLoading={props.isLoading}
          value={endTime}
          onChange={onChangeEndTime}
          errorMessage={errors.endTime}
        />
        <XrInputAv
          type='text'
          required={false}
          label='Catatan'
          disabled={props.isLoading}
          isLoading={props.isLoading}
          value={props.form.notes}
          onChange={onChangeNotes}
          errorMessage={props.errors.notes}
        />

        <XrButtonAv
          size='large'
          color='primary'
          disabled={props.isLoading}
          isLoading={props.isLoading}
          onClick={props.actionFindRoom}
          caption={`Cari Ruangan`}
        />
      </div>
    </XrCardAv>
  )
}

export default FormActivity;